<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="form.modulos.length > 0">
                <rkm-col>
                    <rkm-tabs>
                        <rkm-tab
                            v-for="modulo in form.modulos"
                            :key="modulo.id"
                            :title="modulo.nome"
                        >
                            <rkm-row>
                                <rkm-col>
                                    <rkm-button
                                        @click="handleCheckAll(modulo.id)"
                                        color="primary"
                                        small
                                    >
                                        Marcar todos
                                    </rkm-button>
                                    
                                    <rkm-button
                                        @click="handleUncheckAll(modulo.id)"
                                        outline
                                        small
                                    >
                                        Desmarcar todos
                                    </rkm-button>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row cols="3">
                                <rkm-col
                                    v-for="funcionalidade in modulo.funcionalidades"
                                    :key="funcionalidade.id"
                                >
                                    <rkm-area
                                        :title="funcionalidade.nome"
                                        no-margin-top
                                    >
                                        <rkm-form-checkbox-group v-model="model.permissoes">
                                            <rkm-form-checkbox
                                                v-for="permissao in funcionalidade.permissoes"
                                                :key="permissao.id"
                                                :value="permissao.id"
                                                :label="true"
                                            >
                                                {{permissao.nome}}
                                            </rkm-form-checkbox>
                                        </rkm-form-checkbox-group>
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>
                        </rkm-tab>
                    </rkm-tabs>
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('administracao-papel-form')
        },
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    data: () => ({
        form: {
            modulos: [],
        },
        model: {
            nome: null,
            permissoes: [],
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleCheckAll(modulo_id) {
            this.form.modulos.map(modulo => {
                if (modulo.id === modulo_id) {
                    modulo.funcionalidades.map(funcionalidade => {
                        funcionalidade.permissoes.map(permissao => {
                            if (!this.model.permissoes.includes(permissao.id)) {
                                this.model.permissoes.push(permissao.id)
                            }
                        })
                    })
                }
            })
        },
        handleUncheckAll(modulo_id) {
            this.form.modulos.map(modulo => {
                if (modulo.id === modulo_id) {
                    modulo.funcionalidades.map(funcionalidade => {
                        funcionalidade.permissoes.map(permissao => {
                            const index = this.model.permissoes.findIndex(index => index === permissao.id)

                            if (index >= 0) {
                                this.model.permissoes.splice(index, 1)
                            }
                        })
                    })
                }
            })
        },
        load() {
            this.setLoading('administracao-papel-form')

            if (this.id) {
                this.repositories.administracao.papel
                    .edit(this.id)
                    .then(({ data }) => {
                        this.form.modulos = data.form.modulos
                        this.model.nome = data.model.nome
                        this.model.permissoes = data.model.permissoes
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('administracao-papel-form'))
            } else {
                this.repositories.administracao.papel.create()
                    .then(({ data }) => this.form.modulos = data.form.modulos)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('administracao-papel-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('administracao-papel-form')

                        if (this.id) {
                            this.repositories.administracao.papel.update(this.model, this.id)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('administracao-papel-form'))
                        } else {
                            this.repositories.administracao.papel.store(this.model)
                                .then(({ data }) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('administracao-papel-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>